module.exports = __webpack_public_path__ + "8347bbb902dcb6cb5b19d4e35dfe5010.jpg";